module.exports = __webpack_public_path__ + "img/PPT版_00.a0bf69e1.png";